import axios from '../Api/api';

export default async function register(params) {
  const request = {
    username: params.username,
    password: params.password,
    referralCode: params.referralCode,
    country: "MALAYSIA",
    phoneNo: params.phoneNumber,
    transactionPassword: params.withdrawPassword
  }

  return await axios.post("account/crm/register", request)
    .then((res) => {
      if (res.status === 200) {
        return res.status;
      }
    })
    .catch((error) => {
      throw new Error(error.response.data.message);
    })
}